(function () {
  'use strict';

  var STORAGE_KEY = 'rr_wishlist';
  var config = window.RRWishlistConfig || {};
  var productCache = {};

  /* =========================================================
     STORAGE
  ========================================================= */

  function getItems() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var items = raw ? JSON.parse(raw) : [];

      if (!Array.isArray(items)) {
        return [];
      }

      var clean = items
        .map(function (item) {
          return {
            handle:
              item && item.handle
                ? String(item.handle)
                : '',

            variant_id:
              item && item.variant_id
                ? String(item.variant_id)
                : ''
          };
        })
        .filter(function (item) {
          return (
            item.handle &&
            item.variant_id
          );
        });

      /*
       * Remove old wishlist records that may contain
       * copied product title/image/price data.
       */
      if (
        JSON.stringify(clean) !==
        JSON.stringify(items)
      ) {
        localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify(clean)
        );
      }

      return clean;

    } catch (error) {
      console.error(
        '[Wishlist] Storage error:',
        error
      );

      return [];
    }
  }

  function saveItems(items) {
    var clean = items
      .map(function (item) {
        return {
          handle:
            String(item.handle || ''),

          variant_id:
            String(item.variant_id || '')
        };
      })
      .filter(function (item) {
        return (
          item.handle &&
          item.variant_id
        );
      });

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(clean)
    );

    document.dispatchEvent(
      new CustomEvent(
        'rr:wishlist:updated',
        {
          detail: {
            items: clean
          }
        }
      )
    );
  }

  /* =========================================================
     NORMALIZATION
  ========================================================= */

  function normalize(item) {
    if (!item) {
      return null;
    }

    var handle =
      item.handle || '';

    var variantId =
      item.variant_id ||
      item.variantId ||
      '';

    /*
     * On product page, use currently selected variant.
     */
    var productSection =
      document.querySelector(
        '[data-product-section]'
      );

    if (productSection) {

      var variantInput =
        productSection.querySelector(
          '[data-variant-id]'
        );

      if (
        variantInput &&
        variantInput.value
      ) {
        variantId =
          variantInput.value;
      }
    }

    if (
      !handle ||
      !variantId
    ) {
      return null;
    }

    return {
      handle:
        String(handle),

      variant_id:
        String(variantId)
    };
  }

  function itemKey(item) {
    return (
      String(
        item.handle || ''
      ) +
      '::' +
      String(
        item.variant_id || ''
      )
    );
  }

  function isSaved(item) {
    var target =
      normalize(item);

    if (!target) {
      return false;
    }

    var key =
      itemKey(target);

    return getItems().some(
      function (saved) {
        return (
          itemKey(saved) ===
          key
        );
      }
    );
  }

  function add(item) {
    var product =
      normalize(item);

    if (!product) {
      console.warn(
        '[Wishlist] Cannot add. Missing handle or variant.'
      );

      return false;
    }

    var items =
      getItems();

    var key =
      itemKey(product);

    var exists =
      items.some(
        function (saved) {
          return (
            itemKey(saved) ===
            key
          );
        }
      );

    if (!exists) {
      items.push(product);
      saveItems(items);
    }

    return true;
  }

  function remove(itemOrKey) {

    var key;

    if (
      typeof itemOrKey ===
      'string'
    ) {
      key =
        itemOrKey;
    } else {
      key =
        itemKey(
          itemOrKey || {}
        );
    }

    var items =
      getItems().filter(
        function (item) {
          return (
            itemKey(item) !==
            key
          );
        }
      );

    saveItems(items);
  }

  function clear() {
    saveItems([]);
  }

  /* =========================================================
     MONEY
  ========================================================= */

  function formatMoney(cents) {

    cents =
      Number(cents || 0);

    if (
      window.Shopify &&
      typeof Shopify.formatMoney ===
        'function'
    ) {
      return Shopify.formatMoney(
        cents,
        config.moneyFormat ||
          undefined
      );
    }

    return new Intl.NumberFormat(
      undefined,
      {
        style: 'currency',
        currency:
          config.currency ||
          'INR',
        maximumFractionDigits: 2
      }
    ).format(
      cents / 100
    );
  }

  /* =========================================================
     SECURITY
  ========================================================= */

  function escapeHtml(value) {

    return String(
      value == null
        ? ''
        : value
    )
      .replace(
        /&/g,
        '&amp;'
      )
      .replace(
        /</g,
        '&lt;'
      )
      .replace(
        />/g,
        '&gt;'
      )
      .replace(
        /"/g,
        '&quot;'
      )
      .replace(
        /'/g,
        '&#039;'
      );
  }

  /* =========================================================
     PRODUCT HELPERS
  ========================================================= */

  function getVariant(
    product,
    variantId
  ) {

    if (
      !product ||
      !Array.isArray(
        product.variants
      )
    ) {
      return null;
    }

    return (
      product.variants.find(
        function (variant) {
          return (
            String(
              variant.id
            ) ===
            String(
              variantId
            )
          );
        }
      ) || null
    );
  }

  function getProductImage(
    product,
    variant
  ) {

    if (
      variant &&
      variant.featured_image &&
      variant.featured_image.src
    ) {
      return variant
        .featured_image
        .src;
    }

    if (
      variant &&
      variant.image &&
      variant.image.src
    ) {
      return variant
        .image
        .src;
    }

    if (
      product &&
      Array.isArray(
        product.images
      ) &&
      product.images.length
    ) {
      return product.images[0];
    }

    return '';
  }

  function getProductUrl(
    handle,
    variantId
  ) {

    var url =
      (
        window.Shopify &&
        Shopify.routes &&
        Shopify.routes.root
      )
        ? Shopify.routes.root +
          'products/' +
          encodeURIComponent(
            handle
          )
        : '/products/' +
          encodeURIComponent(
            handle
          );

    if (variantId) {
      url +=
        '?variant=' +
        encodeURIComponent(
          variantId
        );
    }

    return url;
  }

  /* =========================================================
     SHOPIFY PRODUCT API
  ========================================================= */

  async function fetchProduct(
    item
  ) {

    var cacheKey =
      item.handle;

    if (
      productCache[cacheKey]
    ) {
      return productCache[
        cacheKey
      ];
    }

    var root =
      (
        window.Shopify &&
        Shopify.routes &&
        Shopify.routes.root
      )
        ? Shopify.routes.root
        : '/';

    var url =
      root +
      'products/' +
      encodeURIComponent(
        item.handle
      ) +
      '.js';

    var response =
      await fetch(
        url,
        {
          method: 'GET',

          headers: {
            Accept:
              'application/json'
          }
        }
      );

    if (!response.ok) {
      throw new Error(
        'Unable to load product'
      );
    }

    var product =
      await response.json();

    productCache[
      cacheKey
    ] = product;

    return product;
  }

  /* =========================================================
     LOAD WISHLIST PRODUCTS
  ========================================================= */

  async function loadWishlistProducts(
    items
  ) {

    var results = [];

    for (
      var i = 0;
      i < items.length;
      i++
    ) {

      var item =
        items[i];

      try {

        console.log(
          '[Wishlist] Loading:',
          item.handle,
          item.variant_id
        );

        var product =
          await fetchProduct(
            item
          );

        console.log(
          '[Wishlist] Product:',
          product
        );

        if (
          !product ||
          !Array.isArray(
            product.variants
          )
        ) {
          throw new Error(
            'Invalid Shopify product response'
          );
        }

        var variant =
          product.variants.find(
            function (v) {
              return (
                String(v.id) ===
                String(
                  item.variant_id
                )
              );
            }
          );

        if (!variant) {
          throw new Error(
            'Variant ' +
              item.variant_id +
              ' not found in product'
          );
        }

        var image = '';

        if (
          variant.featured_image &&
          variant.featured_image.src
        ) {

          image =
            variant
              .featured_image
              .src;

        } else if (
          variant.image &&
          variant.image.src
        ) {

          image =
            variant
              .image
              .src;

        } else if (
          product.featured_image
        ) {

          image =
            product.featured_image;

        } else if (
          product.images &&
          product.images.length
        ) {

          image =
            product.images[0];
        }

        results.push({

          saved: item,

          product:
            product,

          variant:
            variant,

          title:
            product.title,

          image:
            image,

          price:
            Number(
              variant.price ||
              product.price ||
              0
            ),

          compare_at_price:
            Number(
              variant.compare_at_price ||
              0
            ),

          available:
            variant.available !==
            false,

          variant_id:
            String(
              variant.id
            ),

          url:
            '/products/' +
            encodeURIComponent(
              product.handle
            ) +
            '?variant=' +
            encodeURIComponent(
              variant.id
            )
        });

      } catch (error) {

        console.error(
          '[Wishlist ERROR]',
          item,
          error
        );

        results.push({

          saved:
            item,

          failed:
            true,

          title:
            'Product unavailable',

          image:
            '',

          price:
            0,

          compare_at_price:
            0,

          available:
            false,

          variant_id:
            String(
              item.variant_id
            ),

          url:
            '/products/' +
            encodeURIComponent(
              item.handle
            ) +
            '?variant=' +
            encodeURIComponent(
              item.variant_id
            )
        });
      }
    }

    return results;
  }

  /* =========================================================
     ADD TO CART
  ========================================================= */

  async function addToCart(
    item,
    button
  ) {

    var variantId =
      item.variant_id;

    if (!variantId) {

      window.location.href =
        getProductUrl(
          item.handle,
          ''
        );

      return;
    }

    button.disabled =
      true;

    var original =
      button.textContent;

    button.textContent =
      'ADDING...';

    try {

      var response =
        await fetch(
          (
            config.cartAddUrl ||
            '/cart/add.js'
          ),
          {
            method:
              'POST',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body:
              JSON.stringify({
                items: [
                  {
                    id:
                      Number(
                        variantId
                      ),

                    quantity:
                      1
                  }
                ]
              })
          }
        );

      var data =
        await response.json();

      if (!response.ok) {

        throw new Error(
          data.description ||
          data.message ||
          'Unable to add this product.'
        );
      }

      button.textContent =
        'ADDED ✓';

      if (
        window.RadheRadheCart &&
        typeof
          window.RadheRadheCart
            .refresh ===
            'function'
      ) {

        await
          window.RadheRadheCart
            .refresh();

        if (
          typeof
            window.RadheRadheCart
              .open ===
            'function'
        ) {

          window.RadheRadheCart
            .open();
        }
      }

      setTimeout(
        function () {

          button.textContent =
            original;

          button.disabled =
            false;

        },
        1000
      );

    } catch (error) {

      console.error(
        '[Wishlist Cart Error]',
        error
      );

      button.textContent =
        'TRY AGAIN';

      setTimeout(
        function () {

          button.textContent =
            original;

          button.disabled =
            false;

        },
        1400
      );
    }
  }

  /* =========================================================
     TOAST
  ========================================================= */

  function toast(
    message
  ) {

    var el =
      document.querySelector(
        '.rr-wishlist-toast'
      );

    if (!el) {

      el =
        document.createElement(
          'div'
        );

      el.className =
        'rr-wishlist-toast';

      document.body.appendChild(
        el
      );
    }

    el.textContent =
      message;

    el.classList.add(
      'is-visible'
    );

    clearTimeout(
      el._timer
    );

    el._timer =
      setTimeout(
        function () {

          el.classList.remove(
            'is-visible'
          );

        },
        1800
      );
  }

  /* =========================================================
     WISHLIST PAGE
  ========================================================= */

  async function renderPage() {

    var page =
      document.querySelector(
        '[data-wishlist-page]'
      );

    if (!page) {
      return;
    }

    var grid =
      page.querySelector(
        '[data-wishlist-grid]'
      );

    var empty =
      page.querySelector(
        '[data-wishlist-empty]'
      );

    var count =
      page.querySelector(
        '[data-wishlist-count]'
      );

    var clearButton =
      page.querySelector(
        '[data-wishlist-clear]'
      );

    var items =
      getItems();

    if (count) {

      count.textContent =
        items.length +
        (
          items.length === 1
            ? ' item saved'
            : ' items saved'
        );
    }

    if (clearButton) {

      clearButton.hidden =
        items.length === 0;
    }

    if (!items.length) {

      if (grid) {
        grid.innerHTML =
          '';
      }

      if (empty) {
        empty.hidden =
          false;
      }

      return;
    }

    if (empty) {
      empty.hidden =
        true;
    }

    if (!grid) {
      return;
    }

    var products =
      await loadWishlistProducts(
        items
      );

    grid.innerHTML =
      products
        .map(
          function (item) {

            var discount =
              item.compare_at_price >
              item.price
                ? Math.round(
                    (
                      (
                        item.compare_at_price -
                        item.price
                      ) /
                      item.compare_at_price
                    ) *
                    100
                  )
                : 0;

            return `
              <article
                class="rr-wishlist-card"
                data-wishlist-card
                data-wishlist-key="${escapeHtml(
                  item.saved.handle +
                  '::' +
                  item.saved.variant_id
                )}"
              >

                <div class="rr-wishlist-media">

                  <a
                    href="${escapeHtml(
                      item.url
                    )}"
                    aria-label="${escapeHtml(
                      item.title
                    )}"
                  >

                    ${
                      item.image
                        ? `
                          <img
                            src="${escapeHtml(
                              item.image
                            )}"
                            alt="${escapeHtml(
                              item.title
                            )}"
                            loading="lazy"
                          >
                        `
                        : ''
                    }

                  </a>

                  ${
                    discount
                      ? `
                        <span class="rr-wishlist-badge">
                          ${discount}% OFF
                        </span>
                      `
                      : ''
                  }

                  <button
                    type="button"
                    class="rr-wishlist-remove"
                    data-wishlist-remove="${escapeHtml(
                      item.saved.handle +
                      '::' +
                      item.saved.variant_id
                    )}"
                    aria-label="Remove ${escapeHtml(
                      item.title
                    )}"
                  >
                    <i class="icon icon-heart-2"></i>
                  </button>

                </div>

                <div class="rr-wishlist-info">

                  <a
                    class="rr-wishlist-name"
                    href="${escapeHtml(
                      item.url
                    )}"
                  >
                    ${escapeHtml(
                      item.title
                    )}
                  </a>

                  <div class="rr-wishlist-price">

                    <span class="rr-wishlist-price-current">
                      ${formatMoney(
                        item.price
                      )}
                    </span>

                    ${
                      item.compare_at_price >
                      item.price
                        ? `
                          <span class="rr-wishlist-price-old">
                            ${formatMoney(
                              item.compare_at_price
                            )}
                          </span>
                        `
                        : ''
                    }

                  </div>

                  <div class="rr-wishlist-card-actions">

                    <button
                      type="button"
                      class="rr-wishlist-add"
                      data-wishlist-add="${escapeHtml(
                        item.saved.handle +
                        '::' +
                        item.saved.variant_id
                      )}"
                      data-wishlist-variant="${escapeHtml(
                        item.variant_id
                      )}"
                      ${
                        item.available ===
                          false ||
                        item.failed
                          ? 'disabled'
                          : ''
                      }
                    >
                      ${
                        item.failed
                          ? 'UNAVAILABLE'
                          : item.available ===
                            false
                          ? 'SOLD OUT'
                          : 'ADD TO BAG'
                      }
                    </button>

                    <a
                      class="rr-wishlist-view"
                      href="${escapeHtml(
                        item.url
                      )}"
                    >
                      VIEW PRODUCT
                    </a>

                  </div>

                </div>

              </article>
            `;
          }
        )
        .join('');
  }

  /* =========================================================
     EXTRACT PRODUCT DATA
  ========================================================= */

  function extractFromCard(
    button
  ) {

    if (!button) {
      return null;
    }

    var handle =
      button.getAttribute(
        'data-product-handle'
      );

    var variantId =
      button.getAttribute(
        'data-variant-id'
      );

    /*
     * PRODUCT PAGE
     */

    if (
      handle &&
      variantId
    ) {

      return {

        handle:
          String(handle),

        variant_id:
          String(variantId)

      };
    }

    /*
     * FALLBACK FOR PRODUCT SECTION
     */

    var section =
      button.closest(
        '[data-product-section]'
      );

    if (section) {

      var sectionHandle =
        section.getAttribute(
          'data-product-handle'
        );

      var variantInput =
        section.querySelector(
          '[data-variant-id]'
        );

      var sectionVariant =
        variantInput
          ? variantInput.value
          : '';

      if (
        sectionHandle &&
        sectionVariant
      ) {

        return {

          handle:
            String(
              sectionHandle
            ),

          variant_id:
            String(
              sectionVariant
            )

        };
      }
    }

    /*
     * COLLECTION PRODUCT CARD
     */

    var card =
      button.closest(
        '.card_product--V01, .card_product, [data-product-card]'
      );

    if (!card) {
      return null;
    }

    var cardHandle =
      card.getAttribute(
        'data-product-handle'
      ) ||
      card.dataset
        .productHandle ||
      '';

    var cardVariant =
      card.getAttribute(
        'data-variant-id'
      ) ||
      card.dataset
        .variantId ||
      '';

    if (!cardHandle) {

      var link =
        card.querySelector(
          'a[href*="/products/"]'
        );

      if (link) {

        var href =
          link.getAttribute(
            'href'
          ) || '';

        var match =
          href.match(
            /\/products\/([^?#/]+)/
          );

        if (match) {

          cardHandle =
            decodeURIComponent(
              match[1]
            );
        }
      }
    }

    if (
      !cardHandle ||
      !cardVariant
    ) {

      return null;
    }

    return {

      handle:
        String(cardHandle),

      variant_id:
        String(cardVariant)

    };
  }

  /* =========================================================
     FORCE WISHLIST VISUAL STATE
  ========================================================= */

  function applyWishlistVisualState(
    button,
    saved
  ) {

    if (!button) {
      return;
    }

    var heart =
      button.querySelector(
        '.icon-heart-2'
      );

    /*
     * Button classes.
     */

    button.classList.toggle(
      'is-wishlisted',
      saved
    );

    button.classList.toggle(
      'active',
      saved
    );

    /*
     * Accessibility.
     */

    button.setAttribute(
      'aria-label',
      saved
        ? 'Remove from wishlist'
        : 'Add to wishlist'
    );

    button.setAttribute(
      'aria-pressed',
      saved
        ? 'true'
        : 'false'
    );

    /*
     * FORCE RED WHEN SAVED.
     */

    if (saved) {

      button.style.setProperty(
        'color',
        '#e53935',
        'important'
      );

      button.style.setProperty(
        'border-color',
        '#e53935',
        'important'
      );

      if (heart) {

        heart.style.setProperty(
          'color',
          '#e53935',
          'important'
        );

        heart.style.setProperty(
          '-webkit-text-fill-color',
          '#e53935',
          'important'
        );

        heart.style.setProperty(
          'fill',
          '#e53935',
          'important'
        );
      }

    } else {

      /*
       * RESTORE NORMAL BLACK STATE.
       */

      button.style.setProperty(
        'color',
        '#111111',
        'important'
      );

      button.style.setProperty(
        'border-color',
        '#d9d9d9',
        'important'
      );

      if (heart) {

        heart.style.setProperty(
          'color',
          '#111111',
          'important'
        );

        heart.style.setProperty(
          '-webkit-text-fill-color',
          '#111111',
          'important'
        );

        heart.style.setProperty(
          'fill',
          '#111111',
          'important'
        );
      }
    }

    /*
     * Tooltip.
     */

    var tooltip =
      button.querySelector(
        '.tooltip'
      );

    if (tooltip) {

      tooltip.textContent =
        saved
          ? 'Remove from Wishlist'
          : 'Add to Wishlist';
    }
  }

  /* =========================================================
     WISHLIST BUTTON CLICK
     
     CAPTURE PHASE = TRUE
     
     This executes before other theme
     click handlers.
  ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      var target =
        event.target;

      if (!target) {
        return;
      }

      var wishlistButton =
        null;

      if (
        target.nodeType === 1 &&
        typeof target.closest ===
          'function'
      ) {

        wishlistButton =
          target.closest(
            '[data-wishlist]'
          );
      }

      if (!wishlistButton) {
        return;
      }

      event.preventDefault();

      /*
       * Prevent other theme scripts
       * from changing our wishlist state.
       */

      event.stopPropagation();

      /*
       * PRODUCT HANDLE
       */

      var handle =
        wishlistButton.getAttribute(
          'data-product-handle'
        );

      /*
       * VARIANT ID
       */

      var variantId =
        wishlistButton.getAttribute(
          'data-variant-id'
        );

      /*
       * FALLBACK TO PRODUCT SECTION
       */

      if (
        !handle ||
        !variantId
      ) {

        var section =
          wishlistButton.closest(
            '[data-product-section]'
          );

        if (section) {

          if (!handle) {

            handle =
              section.getAttribute(
                'data-product-handle'
              );
          }

          if (!variantId) {

            var variantInput =
              section.querySelector(
                '[data-variant-id]'
              );

            if (variantInput) {

              variantId =
                variantInput.value;
            }
          }
        }
      }

      /*
       * CHECK DATA
       */

      if (
        !handle ||
        !variantId
      ) {

        console.warn(
          '[Wishlist] Missing product data'
        );

        return;
      }

      var item = {

        handle:
          String(handle),

        variant_id:
          String(variantId)

      };

      console.log(
        '[Wishlist] Button clicked:',
        item
      );

      /*
       * GET CURRENT WISHLIST
       */

      var items =
        getItems();

      var key =
        itemKey(item);

      var wasSaved =
        items.some(
          function (saved) {

            return (
              itemKey(saved) ===
              key
            );
          }
        );

      /* =====================================================
         REMOVE
      ===================================================== */

      if (wasSaved) {

        var remaining =
          items.filter(
            function (saved) {

              return (
                itemKey(saved) !==
                key
              );
            }
          );

        saveItems(
          remaining
        );

        /*
         * FORCE NORMAL STATE
         */

        applyWishlistVisualState(
          wishlistButton,
          false
        );

        /*
         * Animation
         */

        wishlistButton.classList.remove(
          'rr-wishlist-pop'
        );

        void wishlistButton.offsetWidth;

        wishlistButton.classList.add(
          'rr-wishlist-pop'
        );

        setTimeout(
          function () {

            wishlistButton.classList.remove(
              'rr-wishlist-pop'
            );

          },
          350
        );

        toast(
          'Removed from Wishlist'
        );

        console.log(
          '[Wishlist] Removed:',
          item
        );

      }

      /* =====================================================
         ADD
      ===================================================== */

      else {

        items.push(
          item
        );

        saveItems(
          items
        );

        /*
         * FORCE RED STATE
         */

        applyWishlistVisualState(
          wishlistButton,
          true
        );

        /*
         * Animation
         */

        wishlistButton.classList.remove(
          'rr-wishlist-pop'
        );

        void wishlistButton.offsetWidth;

        wishlistButton.classList.add(
          'rr-wishlist-pop'
        );

        setTimeout(
          function () {

            wishlistButton.classList.remove(
              'rr-wishlist-pop'
            );

          },
          350
        );

        toast(
          'Added to Wishlist ❤️'
        );

        console.log(
          '[Wishlist] Added:',
          item
        );
      }

      /*
       * Update all buttons.
       */

      updateButtons();

      /*
       * Force clicked button again after
       * updateButtons().
       */

      applyWishlistVisualState(
        wishlistButton,
        !wasSaved
      );

    },
    true
  );

  /* =========================================================
     UPDATE ALL WISHLIST BUTTONS
  ========================================================= */

  function updateButtons() {

    var items =
      getItems();

    document
      .querySelectorAll(
        '[data-wishlist]'
      )
      .forEach(
        function (button) {

          var item =
            extractFromCard(
              button
            );

          if (!item) {
            return;
          }

          var saved =
            items.some(
              function (x) {

                return (
                  itemKey(x) ===
                  itemKey(item)
                );
              }
            );

          /*
           * Force the correct state.
           */

          applyWishlistVisualState(
            button,
            saved
          );
        }
      );
  }

  /* =========================================================
     WISHLIST PAGE BUTTONS
  ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      /*
       * CLEAR WISHLIST
       */

      var clearButton =
        event.target.closest(
          '[data-wishlist-clear]'
        );

      if (clearButton) {

        event.preventDefault();

        if (
          getItems().length &&
          window.confirm(
            'Clear your entire wishlist?'
          )
        ) {

          clear();

          toast(
            'Wishlist cleared'
          );
        }

        return;
      }

      /*
       * REMOVE ITEM FROM WISHLIST PAGE
       */

      var removeButton =
        event.target.closest(
          '[data-wishlist-remove]'
        );

      if (removeButton) {

        event.preventDefault();

        var removeKey =
          removeButton.getAttribute(
            'data-wishlist-remove'
          );

        if (removeKey) {

          remove(
            removeKey
          );

          toast(
            'Removed from Wishlist'
          );
        }

        return;
      }

      /*
       * ADD ITEM TO CART
       */

      var addButton =
        event.target.closest(
          '[data-wishlist-add]'
        );

      if (addButton) {

        event.preventDefault();

        var variant =
          addButton.getAttribute(
            'data-wishlist-variant'
          );

        var addKey =
          addButton.getAttribute(
            'data-wishlist-add'
          );

        if (!variant) {
          return;
        }

        var parts =
          addKey
            ? addKey.split(
                '::'
              )
            : [];

        var item = {

          handle:
            parts[0] || '',

          variant_id:
            String(variant)

        };

        addToCart(
          item,
          addButton
        );
      }
    }
  );

  /* =========================================================
     EVENTS
  ========================================================= */

  document.addEventListener(
    'rr:wishlist:updated',
    function () {

      renderPage();

      updateButtons();
    }
  );

  /* =========================================================
     PUBLIC API
  ========================================================= */

  window.RRWishlist = {

    get:
      getItems,

    add:
      add,

    remove:
      remove,

    clear:
      clear,

    has:
      isSaved,

    render:
      renderPage

  };

  /* =========================================================
     INITIALIZE
  ========================================================= */

  function initializeWishlist() {

    renderPage();

    updateButtons();
  }

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeWishlist
    );

  } else {

    initializeWishlist();
  }

})();